import { useEffect, useState } from 'react';

import useFlyingFrom from '@shared/v2/hooks/useFlyingFrom';

import useSearchQuery from '@/hooks/useSearchQuery';
import isDomestic from '@/utils/isDomestic';
import filterDestinationsFromFeaturedProperties from '../../utils/filterDestinationsFromFeaturedProperties';
import filterFeaturedPropertiesByDestination from '../../utils/filterFeaturedPropertiesByDestination';
import filterFeaturedPropertiesByOrigin from '../../utils/filterFeaturedPropertiesByOrigin';
import getOriginsFromProperties from '../../utils/getOriginsFromProperties';

const useCampaignData = ({ destinations, tiles: campaignProperties }) => {
  const {
    searchQuery: { destination: destinationName },
    setSearchQuery,
  } = useSearchQuery();

  const [originCodes, setOriginCodes] = useState([]);
  const [destinationNames, setDestinationNames] = useState([]);

  const [filteredProperties, setFilteredProperties] =
    useState(campaignProperties);
  const [filteredDestinations, setFilteredDestinations] = useState([]);

  const setDestinationName = (value) => {
    setSearchQuery({ destination: value || undefined });
  };

  const { originCode, setOriginCode } = useFlyingFrom(originCodes);

  useEffect(() => {
    const filteredByOrigin = filterFeaturedPropertiesByOrigin(
      campaignProperties,
      originCode,
    );

    setDestinationNames([
      ...new Set(
        filteredByOrigin.map(
          (property) => property.propertyContent.destination.name,
        ),
      ),
    ]);

    setFilteredProperties(
      filterFeaturedPropertiesByDestination(filteredByOrigin, destinationName),
    );
  }, [campaignProperties, destinationName, originCode]);

  useEffect(() => {
    setOriginCodes(
      getOriginsFromProperties(campaignProperties).filter(isDomestic),
    );

    setFilteredDestinations(
      filterDestinationsFromFeaturedProperties(
        destinations,
        filteredProperties,
      ),
    );
  }, [destinations, filteredProperties, campaignProperties]);

  return {
    originCode,
    setOriginCode,
    originCodes,
    destinationName,
    setDestinationName,
    destinationNames,
    filteredProperties,
    filteredDestinations,
  };
};

export default useCampaignData;
